const removePendingCredentialFromSessionStorage = () => {
  sessionStorage.removeItem('anova_pending_credential')
}

export default removePendingCredentialFromSessionStorage
